<template>
  <div id="FPS-Report">
    <div class="container admin-wrap mt-5">
      <div class="row header mb-3">
        <div class="col-lg-5">
          <h3 class="text-left">FPS REPORT</h3>
        </div>
      </div>
      <div>
        <div class="tl-search-bar">
          <el-date-picker
            v-model="inputFromDate"
            type="daterange"
            range-separator="TO"
            start-placeholder="From Date"
            end-placeholder="To Date"
            format="dd/MM/yyyy"
            value-format="dd/MM/yyyy"
          >
          </el-date-picker>
          <!--<el-select v-model="inputDateMonth" placeholder="Please select Date Month">-->
          <!--<el-option v-for="item in DateMonthOptions" :key="item.value"-->
          <!--:label="item.label" :value="item.value">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <!--<el-select v-model="inputDateYear" placeholder="Please select year">-->
          <!--<el-option v-for="item in DateYearOptions" :key="item.value"-->
          <!--:label="item.label" :value="item.value">-->
          <!--</el-option>-->
          <!--</el-select>-->
          <el-button class="" v-on:click="Search()">Search </el-button>
        </div>
        <div class="empty-list_image" v-if="FPSListInt.length < 1">
          <!--<strong>{{startupText}}</strong>-->
          <img src="../assets/notfound.png" />
        </div>
        <div class="">
          <div v-if="FPSListInt.length > 0" class="datatable_group">
            <el-button size="small" type="primary" icon="el-icon-download" v-on:click="DownloadExcel()" class="pull-right mb-3">Download </el-button>
            <data-tables
              :data="FPSListInt"
              :page-size="pageSize"
              :pagination-props="{ pageSizes: [pageSize, 100] }"
              width="55"
              stripe
              tooltip-effect="light"
              border
              ref="FPSListTable"
            >
              <el-table-column label="#" min-width="45px">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column v-for="item in FPSList" min-width="150px" :prop="item.prop" :label="item.label" :key="item.prop" sortable="custom">
              </el-table-column>
            </data-tables>
          </div>
        </div>
      </div>
      <!--<div class="empty-list_image"-->
      <!--v-if="FPSListInt.length<1">-->
      <!--&lt;!&ndash;<strong>{{startupText}}</strong>&ndash;&gt;-->
      <!--<img src="../assets/notfound.png"/>-->
      <!--</div>-->
    </div>
  </div>
</template>
<script>
import DataSource from '../data/datasource'
import Cookies from 'js-cookie'
import XLSX from 'xlsx'

export default {
  name: 'FPSReport',
  async created() {
    // this.schoolID = Cookies.get('schoolSession');
    // console.log('1: ',this.schoolID);
    // await this.BindFPSReport();
  },
  async mounted() {},
  data() {
    return {
      // inputDateMonth: '',
      // inputDateYear: '',
      // DateYearOptions: [{
      //     value: new Date().getFullYear() - 1 ,
      //     label: new Date().getFullYear() - 1
      // }, {
      //     value: new Date().getFullYear() ,
      //     label: new Date().getFullYear()
      // }],
      // DateMonthOptions: [{
      //     value: '1',
      //     label: 'Jan'
      // }, {
      //     value: '2',
      //     label: 'Feb'
      // }, {
      //     value: '3',
      //     label: 'March'
      // }, {
      //     value: '4',
      //     label: 'April'
      // }, {
      //     value: '5',
      //     label: 'May'
      // }, {
      //     value: '6',
      //     label: 'June'
      // }, {
      //     value: '7',
      //     label: 'July'
      // }, {
      //     value: '8',
      //     label: 'Aug'
      // }, {
      //     value: '9',
      //     label: 'Sept'
      // }, {
      //     value: '10',
      //     label: 'Oct'
      // }, {
      //     value: '11',
      //     label: 'Nov'
      // }, {
      //     value: '12',
      //     label: 'Dec'
      // }],
      inputFromDate: [],

      FPSListInt: [],

      /* FPSList: [
                    {
                        prop: "Index_No",
                        label: "Student No"
                    },{
                        prop: "Full_Name",
                        label: "Full Name"
                    },{
                        prop: "Middle_name",
                        label: "Middle Name"
                    },{
                        prop: "Last_name",
                        label: "Last Name"
                    },{
                        prop: "DOB_Convert",
                        label: "DOB"
                    },{
                        prop: "student_type",
                        label: "Student Type"
                    },{
                        prop: "Nationality",
                        label: "Nationality"
                    },{
                        prop: "sex",
                        label: "Gender"
                    },{
                        prop: "ID_Number",
                        label: "ID Number"
                    }, {
                        prop: "id_type",
                        label: "ID Type"
                    },{
                        prop: "CourseProgrammeName",
                        label: "Course Name"
                    },{
                        prop: "SCRS_From_Date_Convert",
                        label: "Course From Date"
                    },{
                        prop: "SCRS_To_Date_Convert",
                        label: "Course To Date"
                    },{
                        prop: "Course_duration",
                        label: "Course Duration in Month"
                    },{
                        prop: "status",
                        label: "Student Status"
                    },{
                        prop: "Amount_Received_From_Student",
                        label: "Amount Received From Student"
                    },{
                        prop: "receiptDate",
                        label: "Amount Received Date"
                    },{
                        prop: "Total_Course_Fee_Payable",
                        label: "Total Course Fee Payable"
                    },{
                        prop: "ProtectionStartDate",
                        label: "Protection Start Date"
                    },{
                        prop: "ProtectionEndDate",
                        label: "Protection End Date"
                    },{
                        prop: "ProtectionAmount",
                        label: "Protection Amount"
                    },{
                        prop: "refundAmount",
                        label: "Amount Refund To Student"
                    },{
                        prop: "nettAmt",
                        label: "Net Amount To Be Protected"
                    },
                ], */

      FPSList: [
        {
          prop: 'Pei_Name',
          label: 'Pei_Name',
        },
        {
          prop: 'FPS_Provider_Name',
          label: 'FPS_Provider_Name',
        },
        {
          prop: 'STP_Status',
          label: 'STP_Status',
        },
        {
          prop: 'Nationality',
          label: 'Nationality',
        },
        {
          prop: 'NRIC_FIN_No_DC',
          label: 'NRIC_FIN_No',
        },
        {
          prop: 'StudentNo',
          label: 'StudentNo',
        },
        {
          prop: 'Student_Name',
          label: 'Student_Name',
        },
        {
          prop: 'Course_Title',
          label: 'Course_Title',
        },
        {
          prop: 'Date_of_Commencement_of_Studies',
          label: 'Date_of_Commencement_of_Studies',
        },
        {
          prop: 'Course_Completion_Date',
          label: 'Course_Completion_Date',
        },
        {
          prop: 'Course_Duration_in_Month',
          label: 'Course_Duration_in_Month',
        },
        {
          prop: 'Total_Course_Fee_Payable',
          label: 'Total_Course_Fee_Payable',
        },
        {
          prop: 'Fee_Collection_Cap',
          label: 'Fee_Collection_Cap',
        },
        {
          prop: 'Escrow_BRN_Or_Insurance_Cert_No',
          label: 'Escrow_BRN_Or_Insurance_Cert_No',
        },
        {
          prop: 'Protection_Start_Date',
          label: 'Protection_Start_Date',
        },
        {
          prop: 'Protection_End_Date',
          label: 'Protection_End_Date',
        },
        {
          prop: 'Protection_Amount',
          label: 'Protection_Amount',
        },
        {
          prop: 'Amount_Received_From_Student',
          label: 'Amount_Received_From_Student',
        },
        {
          prop: 'Amount_Received_Date',
          label: 'Amount_Received_Date',
        },
        {
          prop: 'Instalment_ID',
          label: 'Instalment_ID',
        },
        {
          prop: 'Scheduled_Payment_Amount',
          label: 'Scheduled_Payment_Amount',
        },
        {
          prop: 'Scheduled_Payment_Due_Date',
          label: 'Scheduled_Payment_Due_Date',
        },
        {
          prop: 'Receipt_No',
          label: 'Receipt_No',
        },
      ],

      pageSize: 50,
    }
  },

  methods: {
    async Search() {
      try {
        if (!this.inputFromDate[0] || !this.inputFromDate[1]) {
          this.$notify({
            title: 'Require',
            message: '"Please select date from and date to"',
          })
        } else {
          this.$vs.loading()
          const response = await DataSource.shared.getLibertyReport(this.inputFromDate[0], this.inputFromDate[1])

          if (response) {
            if (response.code === '88') {
              window.location.replace('/')
            } else if (response.code === '99') {
              this.$notify.error({
                title: 'Error',
                message: 'Error 99!',
              })
            } else if (response.code === '2') {
              this.$notify({
                title: 'No Record',
                message: 'No Record Found',
              })
              this.FPSListInt = []
            } else {
              // loop in order to bind diff name for same field from DB, as console will have error with same field name bind
              //response.Table.forEach(obj => {
              //    obj.ProtectionStartDate = obj.receiptDate;
              //obj.ProtectionEndDate = obj.SCRS_To_Date_Convert ;
              //    obj.ProtectionAmount = obj.Amount_Received_From_Student;
              //    }
              //);
              this.FPSListInt = response.Table
            }
          }
        }
      } catch (e) {
        this.results = e
      }
      this.$vs.loading.close()
    },

    //

    DownloadExcel() {
      let exportFPSExcelObject = []
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, '/')

      /* this.FPSListInt.forEach(m => {
                    let tempList = {
                        'Student No': m.Index_No,
                        'Full Name': m.Full_Name,
                        'Middle Name': m.Middle_name,
                        'Last Name': m.Last_name,
                        'DOB': m.DOB_Convert,
                        'Student Type': m.student_type,
                        'Nationality': m.Nationality,
                        'Gender': m.sex,
                        'ID_Number': m.ID_Number,
                        'ID Type': m.id_type,
                        'Course Name': m.CourseProgrammeName,
                        'Course From Date': m.SCRS_From_Date_Convert,
                        'Course To Date': m.SCRS_To_Date_Convert,
                        'Course Duration in Month': m.Course_duration,
                        'Student Status': m.status,
                        'Amount Received From Student': m.ProtectionAmount,
                        'Amount Received Date': m.receiptDate,
                        'Total Course Fee Payable': m.Total_Course_Fee_Payable,
                        'Protection Start Date': m.receiptDate,
                        'Protection End Date': m.ProtectionEndDate,
                        'Protection Amount': m.Amount_Received_From_Student,
                        'Amount Refund To Student': m.refundAmount,
                        'Net Amount To Be Protected': m.nettAmt
                    };
                    exportFPSExcelObject.push(tempList);
                }); */

      this.FPSListInt.forEach(m => {
        let tempList = {
          Pei_Name: m.Pei_Name,
          FPS_Provider_Name: m.FPS_Provider_Name,
          STP_Status: m.STP_Status,
          Nationality: m.Nationality,
          NRIC_FIN_No: m.NRIC_FIN_No_DC,
          StudentNo: m.StudentNo,
          Student_Name: m.Student_Name,
          Course_Title: m.Course_Title,
          Date_of_Commencement_of_Studies: m.Date_of_Commencement_of_Studies,
          Course_Completion_Date: m.Course_Completion_Date,
          Course_Duration_in_Month: m.Course_Duration_in_Month,
          Total_Course_Fee_Payable: m.Total_Course_Fee_Payable,
          Fee_Collection_Cap: m.Fee_Collection_Cap,
          Escrow_BRN_Or_Insurance_Cert_No: m.Escrow_BRN_Or_Insurance_Cert_No,
          Protection_Start_Date: m.Protection_Start_Date,
          Protection_End_Date: m.Protection_End_Date,
          Protection_Amount: m.Protection_Amount,
          Amount_Received_From_Student: m.Amount_Received_From_Student,
          Amount_Received_Date: m.Amount_Received_Date,
          Instalment_ID: m.Instalment_ID,
          Scheduled_Payment_Amount: m.Scheduled_Payment_Amount,
          Scheduled_Payment_Due_Date: m.Scheduled_Payment_Due_Date,
          Receipt_No: m.Receipt_No,
        }
        exportFPSExcelObject.push(tempList)
      })

      var sheet2WS = XLSX.utils.json_to_sheet(exportFPSExcelObject)
      var wb2 = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb2, sheet2WS, 'sheet2') // sheetAName is name of Worksheet
      //XLSX.writeFile(wb2, 'FPS Report - ' + currentDateWithFormat + '.xlsx'); // name of the file is 'book.xlsx'
      XLSX.writeFile(wb2, 'FPS New Report - ' + currentDateWithFormat + '.xlsx') // name of the file is 'book.xlsx'
    },
  },
}
</script>
<style scoped>
.tl-search-bar .el-select,
.tl-search-bar .el-date-editor {
  margin: 0 10px;
  flex: 1;
}
.tl-search-bar button {
  background: #007bff !important;
  color: white;
  border: 0px;
}

.tl-search-bar {
  display: flex;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: 1px solid #edf0f4;
  margin-bottom: 20px;
}
</style>
